<div class="max-width-p">
  <benefit-header-summary
    headerText="{{
      'FLEXIBLE_FIXED_BENEFITS.FIXED_BENEFITS_HEADER_TEXT' | translate
    }}"
    [showBudgetCard]="false">
  >
  </benefit-header-summary>
  <div>
    {{ 'FLEXIBLE_FIXED_BENEFITS.FIXED_BENEFITS_HERO1' | translate }}
    {{ 'FLEXIBLE_FIXED_BENEFITS.FIXED_BENEFITS_HERO2' | translate }}
  </div>
  <div class="container-benefits">
    <div class="fix-benefits" *ngIf="fixedBenefits">
      <div
        *ngFor="let fixedBenefit of fixedBenefits"
        class="card clickable"
        (click)="openFixedBenefitInfoPage(fixedBenefit.companyFixedBenefitId)"
      >
        <div class="d-flex align-items-center justify-content-center">
          <div *ngIf="fixedBenefit.pictureUrl; else noPicture">
            <img
              [src]="fixedBenefit.pictureUrl"
              [alt]="fixedBenefit.name"
            />
          </div>
          <ng-template #noPicture>
            <img
              src="assets/images/avatars/no-image.jpg"
              [alt]="fixedBenefit.name"
            />
          </ng-template>
        </div>
        <div class="card-body">
          <div class="card-title">{{ fixedBenefit.name }}</div>
        </div>

        <div class="detail-link">
          <a href="javascript:void(0)" class="card-link c-company"
            >{{
              'FLEXIBLE_FIXED_BENEFITS.FIXED_BENEFITS_MORE_LINK' | translate
            }}
            <span class="icon-chevron-right feather ficon"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center load-more-container">
    <button *ngIf="fixedBenefits.length < totalBenefits" class="btn btn-secondary bold" (click)="loadMoreBenefits()">
      {{ 'FLEXIBLE_FIXED_BENEFITS.LOAD_MORE' | translate }}
    </button>
  </div>
</div>
